/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';

const VipBadge = () => {
  return (
    <View style={styles.statusWrapper}>
      <SociollaText type="medium" style={styles.statusText}>
        VIP
      </SociollaText>
    </View>
  );
};

const styles = StyleSheet.create({
  statusWrapper: {
    top: -2,
    paddingVertical: 2,
    marginRight: 5,
    paddingHorizontal: 4,
    borderWidth: 1,
    borderRadius: 4,
    borderColor: Colors.red0,
    alignSelf: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  statusText: { color: Colors.red0, fontSize: 8 },
});

export default VipBadge;
